import LoadingComponent from "components/LoadingComponent";
import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WithAuthWrapper from "withWrapper/withAuthWrapper";
import AddViewVoucherModal from "./Modal";
import VoucherTable from "./table";
import {
  createVoucherThunk,
  getLoadingStatus,
  getVoucherThunk,
  getVouchers
} from "redux/slices/voucherSlice";
import { NewVoucher, Voucher } from "types/Voucher";

const headers = [
  { id: "id", name: "Id" },
  { id: "title", name: "Title" },
  { id: "Type", name: "Type" },
  { id: "Price", name: "Price" },
  { id: "Status", name: "Status" },
  { id: "created", name: "Created At" },
  { id: "actions", name: "Actions" }
];
const VoucherPage: React.FC = () => {
  const accessToken = localStorage.getItem("stmpz-token");
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const dispatch = useDispatch();
  const vouchers = useSelector(getVouchers);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isView, setViewModal] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<Voucher>();
  const isLoading = useSelector(getLoadingStatus);
  const [hasFetched, setHasFetched] = useState(false);

  const getVoucherPage = useCallback(
    (page: number) => {
      if (accessToken) {
        dispatch(getVoucherThunk({ accessToken, businessId }));
      }
    },
    [accessToken, businessId, dispatch]
  );
  useEffect(() => {
    if (accessToken && !hasFetched) {
      setHasFetched(true);
      getVoucherPage(1);
    }
  }, [accessToken, getVoucherPage, hasFetched]);

  const createNewVoucherPage = useCallback(
    (voucher: NewVoucher) => {
      if (accessToken) {
        dispatch(
          createVoucherThunk({
            accessToken,
            newVoucher: voucher,
            businessId: businessId
          })
        );
        setModalOpen(false);
        getVoucherPage(1);
      }
    },
    [accessToken, businessId, dispatch, getVoucherPage]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddViewVoucherModal
        open={isModalOpen}
        isView={isView}
        selectedRow={selectedRow}
        handleClose={() => setModalOpen(false)}
        createNewVoucher={createNewVoucherPage}
      />
      {!isLoading ? (
        <VoucherTable
          header={headers}
          rows={vouchers}
          onPageChanged={(newPage: number) => getVoucherPage(newPage + 1)}
          onReload={() => getVoucherPage(1)}
          addNewOrViewVoucher={(isView: boolean, selectedRow?: Voucher) => {
            setSelectedRow(selectedRow);
            setViewModal(isView);
            setModalOpen(true);
          }}
        />
      ) : (
        <LoadingComponent />
      )}
    </DashboardLayout>
  );
};

export default WithAuthWrapper(VoucherPage);
